/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IJumpingS2Data, ISerialData, ISerialGameData} from "./ISerialData";
import {IParsedStackedSymbolName, StackedSymbol} from "../../../core/reel/stackedsymbol/StackedSymbol";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {SerialGameConfig} from "../../SerialGameConfig";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {SerialGameMode} from "../SerialGameMode";

export class SerialDataParser {

    constructor() {}

    public parseReels(rawData:ISerialData):string[][] {
        // if(rawData.hasOwnProperty("isRestoreState") && rawData.isRestoreState) {
        //     return this.parseStackedSymbolsInReels(this.filterRestoreWXN(rawData.reels, rawData.lockedSymbolsNextSpin));
        // }
        return this.parseStackedSymbolsInReels(rawData.reels);
    }

    // private filterRestoreWXN(rawReels:string[][], lockedSymbolsNextSpin:string[][]):string[][] {
    //     let result:string[][] = [];
    //     rawReels.forEach((rawReel, reelId) => {
    //         result.push([]);
    //         rawReel.forEach((sym, symId) => {
    //             result[reelId].push(lockedSymbolsNextSpin[reelId][symId] === "WXN" ? "WXN": sym);
    //         });
    //     });
    //
    //     return result;
    // }

    public parseStackedSymbolsInReels(rawReels:string[][], parsedSymbolNamesUnder?:string[]):string[][] {
        let result:string[][] = [];

        rawReels.forEach((rawReel, reelId) => {
            result.push(this.parseStackedSymbolsInReel(rawReel, reelId, parsedSymbolNamesUnder == null ? undefined : parsedSymbolNamesUnder[reelId]));
        });

        return result;
    }

    // Always start to parse the reel from the bottom because in all cases the bottom of the reel is already known.
    // For special cases like the reel is up side down, please create your own parsing.
    public parseStackedSymbolsInReel(rawReel:string[], reelIndex:number, parsedSymbolNameUnder?:string):string[] {
        const input:string[] = rawReel.concat();
        const result:string[] = [];

        if(parsedSymbolNameUnder == null) {
            let bottomStackedSymName:IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1], reelIndex);
            // Find out if the reel has half stacked symbols in the bottom
            if(bottomStackedSymName.isStacked) {
                let i:number;
                for(i = 1; i < input.length; i++) {
                    const testStackedSymName:IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1 - i], reelIndex);
                    if(testStackedSymName.isStacked && testStackedSymName.symName === bottomStackedSymName.symName) {
                        bottomStackedSymName = testStackedSymName;
                    } else {
                        break;
                    }
                }
                // i is the first symbol that's not in the stack.
                i = i % bottomStackedSymName.totalNum; // If num of stacked symbols in the bottom is bigger than stacked.totalNum.
                parsedSymbolNameUnder = `${bottomStackedSymName.symName}*${i.toString()}`;
            } else {
                parsedSymbolNameUnder = "NonStackedDummySym";
            }
        }

        while(input.length > 0) {
            const stackedSymNameUnder:IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(result.length > 0 ? result[0] : parsedSymbolNameUnder, reelIndex);
            const stackedSymName:IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input.pop()!, reelIndex);

            // For continue stacked symbol
            if(stackedSymNameUnder.isStacked && stackedSymNameUnder.index > 0) {
                if(!stackedSymName.isStacked || stackedSymName.symName !== stackedSymNameUnder.symName) {
                    debugger;
                    Logger.logDev("If you are using the outcome setter, this might be a case that the outcome made an illegal server data. Please take to the server dev to check if that worth a fix.");
                    throw new Error(`ServerDataParser.parseStackedSymbolsInReel():reelId = ${reelIndex}, reelData = ${rawReel.toString()}, symName = ${stackedSymName.symName}, the symbol should be ${stackedSymName.totalNum}-stacked!`);
                }
                result.unshift(`${stackedSymName.symName}*${(stackedSymNameUnder.index - 1).toString()}`);
                continue;
            }

            // For starting a new stacked symbol
            if(stackedSymName.isStacked) {
                result.unshift(`${stackedSymName.symName}*${(stackedSymName.totalNum - 1).toString()}`);
                continue;
            }

            // For non stacked symbol
            result.unshift(stackedSymName.symName);
        }

        return result;
    }

    // Game Data:

    public parseWinRatio(winRatio:number):IWinRatioConfig | null {
        let ratioConfigs:IWinRatioConfig[] = SerialGameConfig.WIN_RATIOS;

        let ratioConfig;
        for(let i:number = ratioConfigs.length - 1; i >= 0; i--) {
            const config = ratioConfigs[i];
            if(winRatio >= config.ratio) {
                ratioConfig = config;
                break;
            }
        }

        if(ratioConfig) {
            return {
                ratio : winRatio,
                name : ratioConfig.name,
                duration : ratioConfig.duration,
                bigWinLevel : ratioConfig.bigWinLevel
            }
        }
        return null;
    }

    public parseEnhancerReelsOpenedNextSpin(rawData:ISerialData):boolean[][] {
        const result:boolean[][] = ArrayHelper.initArrayWithValues<boolean[]>(SerialGameConfig.REELS_NUM, () => {
            return [];
        });

        if(rawData.hasOwnProperty("isRestoreState") && (<any>rawData)[`isRestoreState`] && rawData.nextMode === SerialGameMode.CAPWIN_GAME) {
            rawData.evaluatedArea.forEach((reel, reelId) => {
                const open0 = reel[0] !== "BLANK";
                const open1 = reel[1] !== "BLANK";
                result[reelId][0] = open0;
                result[reelId][1] = open1;
                result[reelId][5] = open1;
                result[reelId][6] = open0;
            });
        } else {
            rawData.enhancerOpenedNextSpin.forEach((opened:boolean[], reelId) => {
                result[reelId][0] = opened[0];
                result[reelId][1] = opened[1];
                result[reelId][5] = opened[1];
                result[reelId][6] = opened[0];
            });
        }

        return result;
    }

    public parseJumpingS2(rawData:ISerialGameData):IJumpingS2Data {
        return rawData.jumpingS2;
    }
}